/**
 * EmoneyPoS component module.
 * @module shared/widgets/EmoneyPoS
 */
import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {Column, DescriptiveText, Image, Row, EMoneyPoSChart} from '../../shared';

const _PoSBoxSmall = styled.div`
  height: 100%;
  width: 100%;
  display: inline-block;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
  text-align: center;
`;

const _RemovableRow = styled(Row)`
  ${props => !props.showLogo && 'visibility: hidden; height: 0px; width: 0px;'}
`;

const _Spacer = styled.div`
  height: 40px;
  visibility: hidden;
`;

/**
 * EmoneyPoS component
 * @name EmoneyPoS
 */
const EmoneyPoS = (props) => {
  const {probabilityOfSuccess, showLogo = false, isQueued, error, layoutSize} = props;

  if (layoutSize === 'xs') {
    return <_PoSBoxSmall>
      <Column>
        <EMoneyPoSChart probabilityOfSuccess={probabilityOfSuccess} layoutSize={layoutSize}/>
        {!probabilityOfSuccess && !isQueued && !error && <DescriptiveText>Setup Needed</DescriptiveText>}
        {isQueued && !error && <DescriptiveText>Retrieving Data</DescriptiveText>}
        {error && <DescriptiveText>Error Loading Data</DescriptiveText>}
      </Column>
    </_PoSBoxSmall>;
  }

  return <Column width={'100%'} height={'100%'} alignItems={'left'} justifySubColumn={'space between'} overflow={'hidden'}>
    <_RemovableRow width={'fit-content'} justifySubRow={'left'} showLogo={showLogo}>
      <Image src={'https://media.circleblack.com/partners/emoney_logo_white.png'} maxHeight={'30px'}/>
    </_RemovableRow>
    <Row>
      <EMoneyPoSChart probabilityOfSuccess={probabilityOfSuccess} layoutSize={layoutSize}/>
    </Row>
    <_RemovableRow width={'fit-content'} justifySubRow={'left'} showLogo={showLogo}>
      <_Spacer>&nbsp;</_Spacer>
    </_RemovableRow>
  </Column>;
};

export default EmoneyPoS;

EmoneyPoS.propTypes = {
  /**
   * The ProbabilityOfSuccess Number to display
   */
  probabilityOfSuccess: PropTypes.number,
  /**
   * Whether or not the Chart display the partner logo above the chart.
   */
  showLogo: PropTypes.bool,
  isQueued: PropTypes.bool,
  error: PropTypes.bool,
  /**
   * The size of the component ('xs', 'sm', or 'md')
   */
  layoutSize: PropTypes.string,
};
